import { shortuid } from './guid';

export function hashCode(string: string, prefix: string = ''): string {
    var hash = 0, i, chr;

    if (string.length === 0) return prefix + shortuid(); //NOTE: We need to have a  unique value of this function result. So even if this is not strictly a hash code based on input, nor theoretically always unique due to the random generation, the risk is extremly low that it is not unique.
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return prefix + hash;
};